import { CampaignFormData } from '@tt4b/ttam-enums';
import { useStdObjectiveType } from '@tt4b/ttam-hooks';
import { computed, Ref } from '@vue/composition-api';
import { AGE_OPTIONS } from './const';

export function useIsSelectedIndustryType(opt: { campaignData: Ref<CampaignFormData> }) {
  const { campaignData } = opt;
  const isSelectedIndustryType = computed(() => Boolean(campaignData.value.industryTypes?.length));
  return {
    isSelectedIndustryType,
  };
}

export function useAgeOptions(opt: { campaignData: Ref<CampaignFormData> }) {
  const { campaignData } = opt;
  const isSelectedIndustryType = computed(() => Boolean(campaignData.value.industryTypes?.length));
  const { isLeadAds } = useStdObjectiveType({ campaignFormData: campaignData });
  const ageOptions = computed(() =>
    AGE_OPTIONS().filter(item => {
      const isDisabledByIsLeadAds = item.disableLeadAds && isLeadAds.value;
      const isDisabledBySelectedIndustry = item.disableSelectedIndustry && isSelectedIndustryType.value;
      return !isDisabledByIsLeadAds && !isDisabledBySelectedIndustry;
    })
  );
  return {
    ageOptions,
  };
}

export function useAgeName(opt: { age: Ref<string[]> }) {
  const { age } = opt;
  const ageMap = computed(() =>
    AGE_OPTIONS().reduce((pre, cur) => {
      pre[cur.value] = cur.name;
      return pre;
    }, {})
  );
  const ageName = computed(() => age.value.map(item => ageMap.value[item] || ''));
  return {
    ageName,
  };
}

export function usePropsAgeLegalPromptVisible(opt: { age: Ref<string[]> }) {
  const { age } = opt;
  const [nolimitOption, specialOption] = AGE_OPTIONS();
  const isShowAgeLegalPrompt = computed(
    () => age.value?.includes(nolimitOption.value) || age.value?.includes(specialOption.value)
  );
  return {
    isShowAgeLegalPrompt,
  };
}
